import { gql } from "apollo-angular";

export const GET_PACKAGES_TYPES = gql`
query GetPackagesTypes {

    packagesTypes
  
  }
    `;

  export default GET_PACKAGES_TYPES;